<div class="nha-tab-group">
	<nav mat-tab-nav-bar mat-stretch-tabs="false" [disableRipple]="true" [tabPanel]="tabPanel">
		@for (tab of tabs$ | async; track tab.label) {
			<a
				mat-tab-link
				[routerLink]="tab.path"
				[queryParamsHandling]="queryParamsHandling"
				routerLinkActive
				#rla="routerLinkActive"
				[active]="tab.isActive !== undefined ? tab.isActive() : rla.isActive"
				nhaTest="tab-link"
				(click)="onLinkClick()"
			>
				@if (tab.icon) {
					<mat-icon>{{ tab.icon }}</mat-icon>
				}

				<div nhaTest="tab-label">{{ tab.label }}</div>

				@if (tab.count || tab.count === 0) {
					<nha-chip [color]="light ? 'blue' : 'white'" [text]="tab.count" class="count" nhaTest="tab-count"></nha-chip>
				}
			</a>
		}
		@for (tab of tabs; track tab.label) {
			<a
				mat-tab-link
				[routerLink]="tab.path"
				[queryParamsHandling]="queryParamsHandling"
				routerLinkActive
				#rla="routerLinkActive"
				[active]="tab.isActive !== undefined ? tab.isActive() : rla.isActive"
				nhaTest="tab-link"
				(click)="onLinkClick()"
			>
				@if (tab.icon) {
					<mat-icon>{{ tab.icon }}</mat-icon>
				}

				<div nhaTest="tab-label">{{ tab.label }}</div>

				@if (tab.count || tab.count === 0) {
					<nha-chip [color]="light ? 'blue' : 'white'" [text]="tab.count" class="count" nhaTest="tab-count"></nha-chip>
				}
			</a>
		}
	</nav>
	<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
